export default {
  production: true,
  app: {
    bundle: 'unowdtc',
    name: 'unowdtc',
    xClientID: 'unow-unowdtc',
    appBuild: 29,
    applicationId: '673195753',
    appName: 'unowdtc-comecast-ui-prod',
    majorVersion: '0',
    minorVersion: '0',
    patchVersion: '1',
    appVersionId: '673198239',
    asn: '52362',
    asnowner: 'Servicios Innovadores de Comunicacion y Entretenimiento, S.A.',
  },
  conviva: {
    ckey: 'd0af5e863cae7cdd87dd6865d97dc2e096d7425a',
    gUrl: 'https://d0af5e863cae7cdd87dd6865d97dc2e096d7425a.ts-testonly.conviva.com',
  },
  configUrl: 'https://config-service-cdn.api-cms.prd.univisionnow.com',
};
